import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import AutomService from "../../../../../services/AutomService/AutomService";
import Close from "@material-ui/icons/Close";
import { useSetRecoilState } from 'recoil';
import { alertState } from "../../../../../recoil-store/recoil-state";

const groupColors = ["rgba(34, 30, 51, 1)", "rgba(89, 72, 118, 1)", "rgba(110, 170, 174, 1)", "rgba(174, 222, 211, 1)",
    "rgba(251, 228, 89, 1)", "rgba(253, 188, 53, 1)", "rgba(252, 134, 47, 1)", "rgba(222, 76, 35, 1)", "rgba(21, 12, 64, 1)", "rgba(77, 24, 177, 1)", "rgba(73, 117, 225, 1)",
    "rgba(99, 225, 221, 1)", "rgba(144, 255, 219, 1)", "rgba(203, 146, 82, 1)"
]

const AutomGroup = (props) => {
    const { selectedGroup, setSelectedGroup, setRefreshAutomGroups, setGroup } = props
    const [groupName, setGroupName] = useState("")
    const [groupColor, setGroupColor] = useState("")
    const { t } = useTranslation();
    const label = "CONTENT.AUTOM-GROUP."

    useEffect(() => {
        setGroupName(selectedGroup.name)
        setGroupColor(selectedGroup.color)
    }, [selectedGroup])

    const handleClose = () => {
        props.setOpen(false);
        if (selectedGroup.name) {
            setSelectedGroup({})
        }
    };
    const setAlert = useSetRecoilState(alertState);

    const onSubmit = async () => {
        if (!groupName || !groupColor) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTOMS.GROUP-REQUIRED'),
                severity: 'error'
            }));
        }
        else if (selectedGroup.name) {
            const res = await AutomService.updateAutomGroup(selectedGroup.id, { name: groupName, color: groupColor })
            if (!res.status) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.AUTOMS.UPDATE-GROUP-FAILED'),
                    severity: 'error'
                }));
            }
            setRefreshAutomGroups((pre) => !pre)
            setGroup((pre) => {
                return { ...pre, name: groupName, color: groupColor }
            })
        }
        else {
            const res = await AutomService.createAutomGroup({ name: groupName, color: groupColor })
            if (!res.status) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.AUTOMS.CREATE-GROUP-FAILED'),
                    severity: 'error'
                }));
            }
        }
        handleClose()
    };

    const handleChange = (value) => {
        if (value.length > 19) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTOMS.MAXIMUM-LENGTH'),
                severity: 'error'
            }));
        }
        setGroupName(value)
    };
    const handleChangeColor = (color) => {
        setGroupColor(color)
    };

    return (
        <Dialog
            id="autom-group-addNew-modal"
            data-test="autom-group-add-new"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: 480,
                    padding: "8px 14px"
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title" className="add-group-header">
                    <h4 className="autom-group-title">{t(`CONTENT.AUTOM-GROUP.${selectedGroup?.name ? "EDIT-AUTOM-GROUP" : "CREATE-NEW-GROUP"}`)}</h4>
                    <Button data-test="cancelgroup-button" onClick={handleClose}>
                        <Close className="autom-group-close-button" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="form-element">
                    <div className="modal-text add-group-name">
                        <div>{t("CONTENT.AUTOM-GROUP.GROUP-NAME")}<span className="mandatory-field">*</span> </div>
                    </div>
                    <small
                        className="conf-field-desc"><em>{t(label + 'GROUP-NAME-HELPER', { type: 'string' })}</em></small>
                    <TextField
                        id="filled-size-small"
                        autoFocus
                        style={{
                            backgroundColor: "#fff",
                            width: "100%",
                        }}
                        value={groupName}
                        variant="outlined"
                        size="small"
                        inputProps={{ style: { fontSize: 12 } }}
                        onChange={(e) => handleChange(e.target.value)}
                    />

                </div>
                <div className="form-element add-group-color-container">
                    <div className="modal-text add-group-name">
                        <div>{t("CONTENT.AUTOM-GROUP.GROUP-COLOR")}<span className="mandatory-field">*</span> </div>
                    </div>
                    <small
                        className="conf-field-desc"><em>{t(label + 'GROUP-COLOR-HELPER', { type: 'string' })}</em></small>
                    <div className="colors-container">
                        {groupColors.map((color, index) => {
                            return <div id={`color${index}`} className="color-div" style={{
                                backgroundColor: color,
                                border: `${groupColor ? color === groupColor ? "2px solid green" : "none" : "none"}`
                            }}
                                onClick={(e) => handleChangeColor(color)}></div>
                        })}
                    </div>
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "center",
                    padding: "16px 24px 24px 24px",
                }}
            >
                <div>
                    <button
                        type="button"
                        onClick={onSubmit}
                        data-test="createautom-button"
                        className={`button-save`}
                        style={{
                            width: "128px",
                            height: "27px",
                            borderRadius: "4px",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                            opacity: `${!groupColor || !groupName ? "0.5" : "1"} `
                        }}
                        disabled={!groupColor || !groupName}
                    >
                        {t(`CONTENT.AUTOM-GROUP.${selectedGroup?.name ? "EDIT-GROUP" : "ADD-GROUP"}`)}
                    </button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default AutomGroup;
